import React, { useEffect } from "react";


import { ReactSVG } from "react-svg";


import { Col, Row } from "react-bootstrap";


import iconArrowUp from "@Icons/SVG/icon-arrow_up-m-orange.svg";


import "./index.scss";


export type FormSectionComponentVisibilityType = {
    visibilitySwitcher: boolean;
    visibilityStatus: boolean;
};

const SectionVisibilityDefaults:FormSectionComponentVisibilityType = {
    visibilitySwitcher: false, visibilityStatus: true
};

type FormSectionComponentProps = {
    sectionHeaderText?: string;
    sectionVisibility?: FormSectionComponentVisibilityType;
    children?: React.ReactNode | React.ReactNode[];
    className?: string;
};


export const FormSectionComponent:React.FC<FormSectionComponentProps> = ({
    sectionHeaderText, sectionVisibility = SectionVisibilityDefaults,
    children,
    className = 'default-form-section-component'
}) => {

    const { visibilitySwitcher, visibilityStatus: defaultVisibilityStatus } = sectionVisibility;

    const [sectionVisibilityStatus, setSectionVisibilityStatus] = React.useState(defaultVisibilityStatus);

    useEffect(() => {
        return () => {
            setSectionVisibilityStatus(defaultVisibilityStatus);
        };
    }, []);

    const sectionVisibilityStatusHandler = () => {
        setSectionVisibilityStatus(!sectionVisibilityStatus);
    };

    const extraCssClasses = visibilitySwitcher ? ' visibility-toggle': '';

    return (
        <Col xs={12} className={`form-section-component ${className}` + extraCssClasses}>
            <Row className={`form-section-component__content ${className}__content`}>

                {sectionHeaderText &&
                <Col xs={12} className={`form-section-component__header ${className}__header`}>
                    <span className={'section-header-text'}>{sectionHeaderText}</span>
                    {visibilitySwitcher &&
                    <ReactSVG
                        src={iconArrowUp}
                        onClick={sectionVisibilityStatusHandler}
                        wrapper={'span'} className={'section-header-display-switcher'}
                    />
                    }
                </Col>
                }

                {sectionVisibilityStatus && children}

            </Row>
        </Col>
    );

};


export default FormSectionComponent;
